import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { renderTableTitle } from "@/utils/render.jsx";
import Enterprise from "./MyEnterprise/Enterprise.vue";
import { unitTree, dictList } from "@/service/unit";
import { filterTree } from "@/utils/tool";
export default {
  name: "Unit",
  components: {
    Enterprise
  },
  data() {
    return {
      enterPriseVisible: false,
      EnterpriseRef: null,
      unitTypeList: {},
      unitList: [],
      search: {
        type: [],
        keywords: ""
      },
      unitId: "",
      unitInfo: ""
    };
  },
  computed: {
    columns16() {
      const h = this.$createElement;
      return [{
        title: $t("auerdn4", "单位名称"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "name",
        render: (h, {
          row
        }) => {
          let {
            name,
            code,
            type
          } = row;
          let {
            value
          } = this.unitTypeList.find(item => item.code === type);
          return h("span", [`${name} (${code}-${value})`]);
        },
        tree: true
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        slot: "action",
        width: 200,
        align: "center"
      }];
    },
    showDetail() {
      return this.unitList[0] && this.unitList[0].children && this.unitList[0].children.length > 0;
    },
    filterUnitList() {
      return filterTree(this.unitList, this.search);
    },
    height() {
      return window.innerHeight - 250;
    }
  },
  methods: {
    editUnit(row) {
      this.unitId = row.unitId;
      this.$refs.EnterpriseRef.open(row);
      this.enterPriseVisible = true;
    },
    getunitTypeList() {
      dictList({
        category: "UNIT_TYPE"
      }).then(({
        data: {
          retVal,
          result
        }
      }) => {
        if (result === 0) {
          this.unitTypeList = retVal || [];
        }
      });
    },
    // 设置子级展开
    setShowChildren(data) {
      return data.map(item => {
        item._showChildren = true;
        if (item.children && item.children.length > 0) {
          item.children = this.setShowChildren(item.children);
        }
        return item;
      });
    },
    async getUnitTree() {
      let {
        data: {
          result,
          retVal
        }
      } = await unitTree();
      if (result === 0) {
        this.unitList = this.setShowChildren([retVal]);
        let {
          code,
          name,
          type
        } = retVal;
        console.log(this.unitTypeList, retVal, "this.unitTypeList getUnitTree");
        let {
          value
        } = this.unitTypeList.find(item => item.code === type) || {};
        this.unitInfo = `${name} (${code}-${value || ""})`;
      }
      this.unitId = retVal.unitId;
    },
    async getUnitType() {
      let {
        data: {
          result,
          retVal
        }
      } = await dictList({
        category: "UNIT_TYPE"
      });
      if (result === 0) {
        this.unitTypeList = retVal;
      }
    }
  },
  async mounted() {
    await this.getUnitType();
    await this.getUnitTree();
    console.log("this.unitId", this.unitId);
    this.$refs.EnterpriseRef.open({
      unitId: this.unitId
    });
  }
};